import { PropTypes } from 'prop-types';
import React from 'react';

import SvgImage from '../Global/SvgImage';

const PodcastsLink = ({ podcasts, useTitle = true }) => {
  return (
    <div className="podcasts-subscribe" data-module-id="podcasts_link">
      {useTitle && <p className="sm">Subscribe</p>}
      <div className="podcasts-icons">
        {podcasts &&
          podcasts.map(({ icon, title, url }) => {
            return (
              <a
                aria-label={title}
                data-behavior="podcasts_subscribe"
                data-component-id="podcasts_subscribe_link"
                href={url}
                rel="noreferrer noopener"
                target="_blank"
              >
                <SvgImage alt={title} image={icon} />
              </a>
            );
          })}
      </div>
    </div>
  );
};

PodcastsLink.propTypes = {
  podcasts: PropTypes.object,
  useTitle: PropTypes.bool,
};

export default PodcastsLink;
